module.exports = __webpack_public_path__ + "static/media/s2.a7da3b13.png";